module.exports = {"global":{"featuredCollection":"collection-lend_a_helping_hand"}}


//////////////////
// WEBPACK FOOTER
// ./src/store/data/metadata.json
// module id = ./src/store/data/metadata.json
// module chunks = 2